import { Controller } from "stimulus";
import { copyToClipboard } from "../util/copy_to_clipboard";

export default class extends Controller {
  static targets = ["address", "buttonIcon"];

  copyAddress(e) {
    copyToClipboard(this.addressTarget, this.buttonIconTarget);
  }

  toggleFooterGroup(e) {
    const footerGroup = e.currentTarget;
    const footerGroupLinks = document.getElementById(`${footerGroup.id}-group`);

    footerGroup.classList.toggle("tw-border-b")
    footerGroupLinks.classList.toggle("footer-group-collapsed");
    footerGroupLinks.classList.toggle("tw-border-b");
    footerGroupLinks.classList.toggle("tw-pb-4");
  }
}
